module.exports = __webpack_public_path__ + "static/media/IMG_0056.50ddbf47.jpg";